'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits from "./com.raquo.laminar.api.-Implicits.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024 from "./com.raquo.laminar.modifiers.-Renderable-Seq$collection-Seq-Renderable$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_package$package$$anon$5(elements$4, labelMapper$4, mapper$2) {
  this.lJ = null;
  this.zq = null;
  this.zr = null;
  this.HS = null;
  this.lJ = elements$4;
  this.zq = labelMapper$4;
  this.zr = mapper$2;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_package$package$$anon$5 as $c_Ldev_cheleb_scalamigen_package$package$$anon$5 };
$p = $c_Ldev_cheleb_scalamigen_package$package$$anon$5.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_package$package$$anon$5;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_package$package$$anon$5() {
}
export { $h_Ldev_cheleb_scalamigen_package$package$$anon$5 as $h_Ldev_cheleb_scalamigen_package$package$$anon$5 };
$h_Ldev_cheleb_scalamigen_package$package$$anon$5.prototype = $p;
$p.dJ = (function() {
  return this.HS;
});
$p.dt = (function(x$1) {
  this.HS = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.bt = (function(path, variable, factory, errorBus) {
  var labels = this.lJ.a7(this.zq).bH(this.lJ);
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(factory.uw(this.lJ.a7(this.zr).kY(variable.a4().b3().C(), 0), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v1$2) => {
    var idx = (v1$2 | 0);
    $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(variable, this.zr.j(this.lJ.X(idx)));
  }))), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits.$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d, labels.a7(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    var label = x$1$2.ac;
    var a = x$1$2.ad;
    return factory.uv(label, this.lJ.a7(this.zq).kY(label, 0), $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(a, variable.a4().b3().C()));
  }))), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())]))]));
});
var $d_Ldev_cheleb_scalamigen_package$package$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_package$package$$anon$5, "dev.cheleb.scalamigen.package$package$$anon$5", ({
  jr: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_package$package$$anon$5 as $d_Ldev_cheleb_scalamigen_package$package$$anon$5 };
